import React from 'react'
import cn from 'classnames'
import type { FC } from 'react'
import s from './Swatch.module.scss'

interface SwatchProps {
    active?: boolean
    disabled?: boolean
    className?: string
    color?: string
    value?: string
    onClick?: (color: string) => void
}

const Swatch: FC<SwatchProps> = ({
    active = false,
    disabled = false,
    className,
    color = '',
    value = '',
    onClick,
    ...props
}) => {
    const rootClassName = cn(s.root, className, {
        [s.active]: active,
        [s.disabled]: disabled
    })

    const bgColorStyles = { backgroundColor: color || '' }

    return (
        // eslint-disable-next-line
        <div
            className={rootClassName}
            {...props}
            onClick={() => onClick?.(value)}
            onMouseEnter={() => onClick?.(value)}
            onFocus={() => onClick?.(value)}
        >
            <div style={bgColorStyles} className={s.item}>
                <button />
            </div>
        </div>
    )
}

export default Swatch
